import Styled from 'styled-components';
import ActionsMenu from '../../../forecast-app/shared/components/action-menu/actions_menu';

export const ActionMenuWrapper = Styled(ActionsMenu)`
	:not(.expanded)  {
	    visibility: hidden;
	}
`;
